import { PDFDocument, rgb } from "pdf-lib";
import { pdfImg, pdfImgTop } from "../settings";

// import * as pdfMake from "pdfmake/build/pdfmake";
// import * as pdfFonts from "pdfmake/build/vfs_fonts";

import * as fontkit from "fontkit";
import $ from "jquery";
import { CreateImageList } from "../3d-configurator";

async function convertToBlackAndWhite(imageBytes) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const image = new Image();
    image.src = URL.createObjectURL(
      new Blob([imageBytes], { type: "image/png" })
    );

    image.onload = () => {
      canvas.width = image.width;
      canvas.height = image.height;

      ctx.drawImage(image, 0, 0);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];

        const avg = (r + g + b) / 3;

        data[i] = data[i + 1] = data[i + 2] = avg;
      }

      ctx.putImageData(imageData, 0, 0);

      canvas.toBlob(async (blob) => {
        const bwImageBytes = await blob.arrayBuffer();
        resolve(bwImageBytes);
      }, "image/png");
    };

    image.onerror = reject;
  });
}

const pdf_logo_url = "public/img/logoPDf.png";
const pdf_water_mark_url = "public/img/water-mark.png";
const pdf_icon_web_url = "public/img/web.png";
const pdf_icon_phone_url = "public/img/phone.png";
const pdf_icon_email_url = "public/img/mail.png";

export async function createPDF(opt = "open") {
  await CreateImageList();

  const uiPdfPhone = "(949) 716-3678";
  const uiPdfEmail = "hello@bonpergola.com";
  const uiPdfWeb = "https://www.bonpergola.com";
  const mainMargins = [30, 130, 30, 60];

  const imageUrls = [
    pdf_logo_url,
    pdf_icon_web_url,
    pdf_icon_phone_url,
    pdf_icon_email_url,
    pdf_water_mark_url,
  ];

  const imageDataUrls = await Promise.all(
    imageUrls.map(async (imageUrl) => {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const reader = new FileReader();
      return await new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    })
  );

  const [
    logoImage,
    websiteIconImage,
    phoneIconImage,
    emailIconImage,
    waterMarkImage,
  ] = imageDataUrls;

  function rgbToHex(rgb) {
    const result = rgb.match(/\d+/g);
    if (!result) return "#000000";
    return `#${parseInt(result[0]).toString(16).padStart(2, "0")}${parseInt(
      result[1]
    )
      .toString(16)
      .padStart(2, "0")}${parseInt(result[2]).toString(16).padStart(2, "0")}`;
  }

  const footerColorWhite = "#ffffff";
  const footerColor = "#222222";

  const footerContent = function () {
    return [
      {
        margin: [0, 0, 0, 0],
        table: {
          widths: [12, "auto", "*", 12, "auto", "*", 12, "auto"],
          body: [
            [
              {
                image: phoneIconImage,
                margin: [0, 25, -30, 30],
                width: 14,
                height: 14,
                alignment: "center",
                style: "footer",
              },
              {
                text: uiPdfPhone,
                margin: [30, 25, 0, 30],
                alignment: "center", // ÃƒÂÃ‚Â¦ÃƒÂÃ‚ÂµÃƒÂÃ‚Â½Ãƒâ€˜Ã¢â‚¬Å¡Ãƒâ€˜Ã¢â€šÂ¬Ãƒâ€˜Ã†â€™ÃƒÂÃ‚Â²ÃƒÂÃ‚Â°ÃƒÂÃ‚Â½ÃƒÂÃ‚Â½Ãƒâ€˜Ã‚Â Ãƒâ€˜Ã¢â‚¬Å¡ÃƒÂÃ‚ÂµÃƒÂÃ‚ÂºÃƒâ€˜Ã‚ÂÃƒâ€˜Ã¢â‚¬Å¡Ãƒâ€˜Ã†â€™
                style: "footer",
                color: footerColorWhite, // ÃƒÂÃ¢â‚¬ËœÃƒâ€˜Ã¢â‚¬â€œÃƒÂÃ‚Â»ÃƒÂÃ‚Â¸ÃƒÂÃ‚Â¹ ÃƒÂÃ‚ÂºÃƒÂÃ‚Â¾ÃƒÂÃ‚Â»Ãƒâ€˜Ã¢â‚¬â€œÃƒâ€˜Ã¢â€šÂ¬ Ãƒâ€˜Ã¢â‚¬Å¡ÃƒÂÃ‚ÂµÃƒÂÃ‚ÂºÃƒâ€˜Ã‚ÂÃƒâ€˜Ã¢â‚¬Å¡Ãƒâ€˜Ã†â€™
              },
              { text: "" },
              {
                image: websiteIconImage,
                width: 14,
                height: 14,
                alignment: "center", // ÃƒÂÃ‚Â¦ÃƒÂÃ‚ÂµÃƒÂÃ‚Â½Ãƒâ€˜Ã¢â‚¬Å¡Ãƒâ€˜Ã¢â€šÂ¬Ãƒâ€˜Ã†â€™ÃƒÂÃ‚Â²ÃƒÂÃ‚Â°ÃƒÂÃ‚Â½ÃƒÂÃ‚Â½Ãƒâ€˜Ã‚Â Ãƒâ€˜Ã¢â‚¬â€œÃƒÂÃ‚ÂºÃƒÂÃ‚Â¾ÃƒÂÃ‚Â½ÃƒÂÃ‚ÂºÃƒÂÃ‚Â¸
                margin: [0, 25, 0, 30],
              },
              {
                text: uiPdfWeb,
                link: uiPdfWeb,
                margin: [0, 25, 0, 30],
                alignment: "center", // ÃƒÂÃ‚Â¦ÃƒÂÃ‚ÂµÃƒÂÃ‚Â½Ãƒâ€˜Ã¢â‚¬Å¡Ãƒâ€˜Ã¢â€šÂ¬Ãƒâ€˜Ã†â€™ÃƒÂÃ‚Â²ÃƒÂÃ‚Â°ÃƒÂÃ‚Â½ÃƒÂÃ‚Â½Ãƒâ€˜Ã‚Â Ãƒâ€˜Ã¢â‚¬Å¡ÃƒÂÃ‚ÂµÃƒÂÃ‚ÂºÃƒâ€˜Ã‚ÂÃƒâ€˜Ã¢â‚¬Å¡Ãƒâ€˜Ã†â€™
                style: "footer",
                color: footerColorWhite,
              },
              { text: "" },
              {
                image: emailIconImage,
                width: 14,
                height: 14,
                alignment: "center", // ÃƒÂÃ‚Â¦ÃƒÂÃ‚ÂµÃƒÂÃ‚Â½Ãƒâ€˜Ã¢â‚¬Å¡Ãƒâ€˜Ã¢â€šÂ¬Ãƒâ€˜Ã†â€™ÃƒÂÃ‚Â²ÃƒÂÃ‚Â°ÃƒÂÃ‚Â½ÃƒÂÃ‚Â½Ãƒâ€˜Ã‚Â Ãƒâ€˜Ã¢â‚¬â€œÃƒÂÃ‚ÂºÃƒÂÃ‚Â¾ÃƒÂÃ‚Â½ÃƒÂÃ‚ÂºÃƒÂÃ‚Â¸
                margin: [0, 25, 0, 30],
              },
              {
                text: uiPdfEmail,
                link: `mailto:${uiPdfEmail}`,
                margin: [0, 25, 30, 30],
                alignment: "center", // ÃƒÂÃ‚Â¦ÃƒÂÃ‚ÂµÃƒÂÃ‚Â½Ãƒâ€˜Ã¢â‚¬Å¡Ãƒâ€˜Ã¢â€šÂ¬Ãƒâ€˜Ã†â€™ÃƒÂÃ‚Â²ÃƒÂÃ‚Â°ÃƒÂÃ‚Â½ÃƒÂÃ‚Â½Ãƒâ€˜Ã‚Â Ãƒâ€˜Ã¢â‚¬Å¡ÃƒÂÃ‚ÂµÃƒÂÃ‚ÂºÃƒâ€˜Ã‚ÂÃƒâ€˜Ã¢â‚¬Å¡Ãƒâ€˜Ã†â€™
                style: "footer",
                color: footerColorWhite, // ÃƒÂÃ¢â‚¬ËœÃƒâ€˜Ã¢â‚¬â€œÃƒÂÃ‚Â»ÃƒÂÃ‚Â¸ÃƒÂÃ‚Â¹ ÃƒÂÃ‚ÂºÃƒÂÃ‚Â¾ÃƒÂÃ‚Â»Ãƒâ€˜Ã¢â‚¬â€œÃƒâ€˜Ã¢â€šÂ¬ Ãƒâ€˜Ã¢â‚¬Å¡ÃƒÂÃ‚ÂµÃƒÂÃ‚ÂºÃƒâ€˜Ã‚ÂÃƒâ€˜Ã¢â‚¬Å¡Ãƒâ€˜Ã†â€™
              },
            ],
          ],
        },
        fillColor: footerColor,
        layout: "noBorders", // ÃƒÂÃ¢â‚¬ËœÃƒÂÃ‚ÂµÃƒÂÃ‚Â· ÃƒÂÃ‚ÂºÃƒÂÃ‚Â¾Ãƒâ€˜Ã¢â€šÂ¬ÃƒÂÃ‚Â´ÃƒÂÃ‚Â¾ÃƒÂÃ‚Â½Ãƒâ€˜Ã¢â‚¬â€œÃƒÂÃ‚Â²
      },
    ];
  };

  function loadImageAsDataUrl(url) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = () => reject("Image load error");
      img.src = url;
    });
  }

  function generateEllipseImage(colorHex) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = 20;
    canvas.height = 20;
    ctx.beginPath();
    ctx.ellipse(10, 10, 9, 9, 0, 0, Math.PI * 2);
    ctx.fillStyle = colorHex;
    ctx.fill();
    return canvas.toDataURL("image/png");
  }

  function generateRectangleImage(colorHex) {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = 30;
    canvas.height = 18;

    ctx.fillStyle = colorHex;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    return canvas.toDataURL("image/png");
  }

  async function generatePDFcontentFromOverview() {
    const itemsOverview = $(".sum__page__main-list__item");
    const content = [];

    for (const item of itemsOverview) {
      const $item = $(item);
      const title = $item
        .find(".sum__page__main-list__title")
        .text()
        .toUpperCase();
      const list = $item.find(".sum__page__main-list__info");
      const itemList = [];

      for (const info of list) {
        const $info = $(info);
        const infoTitle = $info
          .find(".sum__page__main-list__info__title")
          .text();
        const $colorElement = $info.find(".sum__page__main-list__info__color");
        const bgColor = $colorElement.css("background-color");
        const bgImage = $colorElement.css("background-image");
        const value = $info.find(".sum__page__main-list__info__param").text();

        const result = [];

        if (bgImage && bgImage !== "none") {
          const match = bgImage.match(/url\(["']?(.*?)["']?\)/);
          if (match && match[1]) {
            let imageUrl = match[1].replace(/^public\//, "/");
            try {
              const imageDataUrl = await loadImageAsDataUrl(imageUrl);
              result.push({
                image: imageDataUrl,
                width: 20,
                height: 20,
                alignment: "left",
                style: "itemValue",
                margin: [0, 0, 0, 0],
                border: [false, false, false, false],
              });
            } catch {
              result.push({ text: infoTitle, style: "itemFirst" });
            }
          }
        } else if (
          bgColor &&
          bgColor !== "rgba(0, 0, 0, 0)" &&
          bgColor !== "transparent"
        ) {
          const colorHex = rgbToHex(bgColor);
          const ellipseImg = generateRectangleImage(colorHex);
          result.push({
            image: ellipseImg,
            width: 30,
            height: 18,
            alignment: "left",
            style: "itemValue",
            margin: [0, 0, 0, 0],
            border: [false, false, false, false],
          });
        } else {
          result.push({
            text: infoTitle,
            style: "itemFirst",
            border: [false, false, false, false],
          });
        }

        result.push({
          text: value,
          style: "itemValueFirst",
          border: [false, false, false, false],
        });

        itemList.push(result);
      }

      content.push({
        style: "tableItemLeft",
        table: {
          widths: "*",
          body: [
            [
              {
                text: title,
                style: "tableHeader",
                colSpan: 2,
                border: [false, false, false, false],
              },
              {},
            ],
            [
              {
                text: "",
                colSpan: 2,
                border: [false, true, false, false],
                height: 1,
                style: "lineStyle",
              },
              {},
            ],
            ...itemList,
          ],
        },
      });
    }

    return content;
  }

  const overviewContent = await generatePDFcontentFromOverview();

  const pdfContent = [
    {
      margin: [40, 0, 0, 0],
      columns: [
        { image: pdfImg.img, width: 250, height: 120, margin: [0, 0, 0, 0] },
        { image: pdfImgTop.img, width: 250, height: 120, margin: [0, 0, 0, 0] },
        // {
        //   image: waterMarkImage,
        //   width: 80,
        //   height: 80,
        //   absolutePosition: { x: 150, y: 160 },
        //   rotate: 45,
        //   opacity: 1,
        // },
        // {
        //   image: waterMarkImage,
        //   width: 80,
        //   height: 80,
        //   absolutePosition: { x: 400, y: 160 },
        //   rotate: 45,
        //   opacity: 1,
        // },
      ],
    },
    ...overviewContent,
  ];

  const underLogoText =
    "All measurments, design and placement are approximate and subject for approval uppon execution of order.";

  const pdfDefinition = {
    pageMargins: mainMargins,
    header: {
      stack: [
        { image: logoImage, width: 250 },
        {
          text: underLogoText,
          alignment: "center",
          margin: [0, 20, 0, 0],
          color: "#DB1A7D",
        },
      ],
      alignment: "center",
      margin: [15, 15, 15, 15],
    },
    content: pdfContent,
    footer: footerContent(),
    styles: {
      tableHeader: {
        fontSize: 10,
        bold: true,
        color: "black",
        alignment: "center",
        margin: [0, 5, 0, 8],
      },
      itemFirst: {
        fontSize: 10,
        color: "black",
        alignment: "left",
      },
      itemValue: {
        fontSize: 10,
        color: "#DB1A7D",
        alignment: "right",
      },
      itemValueFirst: {
        fontSize: 10,
        color: "#DB1A7D",
        alignment: "right",
      },
      lineStyle: {
        borderBottom: "0.5px solid #DB1A7D",
        borderTop: "0.5px solid #DB1A7D",
        marginBottom: 5,
      },
      tableItemLeft: {
        fontSize: 10,
        margin: [0, 0, 0, 0],
      },
    },
    defaultStyle: {
      font: "Roboto",
    },
  };

  switch (opt) {
    case "open":
      pdfMake.createPdf(pdfDefinition).open();
      break;
    case "download":
      pdfMake.createPdf(pdfDefinition).download("Bon Pergola.pdf");
      break;
    case "print":
      pdfMake.createPdf(pdfDefinition).print();
      break;
    case "base64": 
      return new Promise((resolve) => {
        pdfMake.createPdf(pdfDefinition).getBase64((data) => {
          resolve(data);
        });
      });
      break;
  }
}
